// this file is automatically generated by git.version.ts script
export const versions = {commit: 'd1e3e149', tag: '2026.1.006-RELEASE'};
